{
  "es": {
    "building": {
      "attributes": {
        "description": "Descripción",
        "elevators": "Número de ascensores",
        "end_date": "Fecha de fin",
        "floors": "Número de plantas",
        "internal_note": "Nota interna del edificio",
        "name": "Nombre",
        "start_date": "Fecha de inicio",
        "surface_shared": "Superficie de las zonas comunes"
      },
      "labels": {
        "building": "Ningún edificio | Un edificio | {count} edificios"
      },
      "toasts": {
        "create": "Edificio creado",
        "delete": "Edificio eliminado",
        "update": "Edificio actualizado"
      },
      "validation": {
        "needName": "Se requiere un título",
        "needNumber": "Debe ser un número (p. ej. 85)"
      }
    }
  }
}
